import React, { useEffect, useState, useCallback } from "react";
import { toast } from "sonner";
import { Loader2, Trash2, Mail } from "lucide-react";
import api, { errMsg } from "@/lib/api";

export default function MessagesPanel() {
  const [msgs, setMsgs] = useState([]);
  const [loading, setLoading] = useState(true);

  const load = useCallback(() => {
    setLoading(true);
    api.get("/admin/contact").then((r) => setMsgs(r.data)).catch(() => {}).finally(() => setLoading(false));
  }, []);

  useEffect(() => { load(); }, [load]);

  const del = async (id) => {
    try { await api.delete(`/admin/contact/${id}`); setMsgs((m) => m.filter((x) => x.id !== id)); }
    catch (e) { toast.error(errMsg(e.response?.data?.detail)); }
  };

  if (loading) return <div className="py-16 text-center"><Loader2 className="animate-spin text-[var(--vl-gold)] mx-auto" /></div>;

  return (
    <div className="space-y-3" data-testid="messages-panel">
      {msgs.length === 0 && <p className="text-center text-[var(--vl-stone)] py-16">—</p>}
      {msgs.map((m) => (
        <div key={m.id} className="vl-card rounded-xl p-5" data-testid={`message-${m.id}`}>
          <div className="flex items-start justify-between gap-4">
            <div className="min-w-0">
              <div className="flex items-center gap-2 text-[var(--vl-ivory)] font-medium">
                <Mail size={15} className="text-[var(--vl-gold)]" /> {m.name}
              </div>
              <div className="text-sm text-[var(--vl-stone)] mt-0.5">{m.email}{m.phone ? ` · ${m.phone}` : ""}</div>
              <p className="text-sm text-[var(--vl-ivory)]/90 mt-2 whitespace-pre-wrap">{m.message}</p>
              <div className="text-xs text-[var(--vl-stone)]/60 mt-2">{new Date(m.created_at).toLocaleString()}</div>
            </div>
            <button onClick={() => del(m.id)} className="text-red-300 hover:text-red-200 shrink-0" data-testid={`delete-message-${m.id}`}>
              <Trash2 size={16} />
            </button>
          </div>
        </div>
      ))}
    </div>
  );
}
